import React from "react";
import "./style.css";
import RecurrentPaymentForm from "./recurrentPaymentForm";

const PaymentForm = props => {
  const {
    paymentDetails,
    setPaymentDetails,
    onChangeIban,
    ibanError,
    setInstallments,
    installments,
    installmentsError,
    setInstallmentsError
  } = props;

  return (
    <div className="payment-form-container">
      <div className="payment-form">
        <RecurrentPaymentForm
          paymentDetails={paymentDetails}
          setPaymentDetails={setPaymentDetails}
          onChangeIban={onChangeIban}
          ibanError={ibanError}
          setInstallments={setInstallments}
          installments={installments}
          installmentsError={installmentsError}
          setInstallmentsError={setInstallmentsError}
        />
      </div>
    </div>
  );
};

export default PaymentForm;
